import type { BugReportClient } from 'clients/bug-report/interface'
import { SentryBugReportClient } from 'clients/bug-report/sentry-bug-report'

export type {
  BugReport,
  BugReportClient,
  BugReportReporter,
  BugReportScreenshot,
} from 'clients/bug-report/interface'

export const bugReportClient: BugReportClient = new SentryBugReportClient()
